// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tablet":"(max-width: 1024px)","stub__background":"_3fE5jy8nXE8w","stub__content":"_2kEVyuq6XcWf"};